import type { ComponentType } from '@grafikr/components';
import { hide as hideOverlay, show as showOverlay } from 'utils/overlay';
import fastdom from 'fastdom';

const component: ComponentType = (node) => {
  document.documentElement.style.setProperty('--header-height', `${node.scrollHeight}px`);
  document.documentElement.style.setProperty('--viewport', `${window.innerHeight}px`);
  window.addEventListener('resize', () => {
    document.documentElement.style.setProperty('--viewport', `${window.innerHeight}px`);
  });

  const headerClasses: string[] = node.dataset.class.split(' ');
  const defaultClasses: string[] = node.dataset.default.split(' ');
  const megamenuLinks = node.querySelectorAll('.js-has-megamenu');

  megamenuLinks.forEach((link) => {
    link.addEventListener('mouseover', () => {
      node.parentElement.style.zIndex = '60';
      node.parentElement.classList.add('bg-white');
      showOverlay();
    });

    link.addEventListener('mouseleave', () => {
      hideOverlay();
      node.parentElement.style.zIndex = null;
      node.parentElement.classList.remove('bg-white');
    });
  });

  const onScrollListener = () => {
    let lastYPosition = 0;

    fastdom.measure(() => {
      lastYPosition = window.scrollY;
    });

    fastdom.mutate(() => {
      if (
        !sessionStorage.getItem('announcement-bar-closed') ? lastYPosition > 34 : lastYPosition > 1
      ) {
        if (defaultClasses.length > 1) {
          defaultClasses.forEach((HTMLclass) => {
            node.classList.remove(HTMLclass);
          });
        }
        if (headerClasses.length > 1) {
          headerClasses.forEach((HTMLclass) => {
            node.classList.add(HTMLclass);
          });
        }
      } else {
        if (headerClasses.length > 1) {
          headerClasses.forEach((HTMLclass) => {
            node.classList.remove(HTMLclass);
          });
        }
        if (defaultClasses.length > 1) {
          defaultClasses.forEach((HTMLclass) => {
            node.classList.add(HTMLclass);
          });
        }
      }
    });
  };

  window.addEventListener('scroll', onScrollListener);

  if (window.location.search.includes('?cart')) {
    const toggleCart: HTMLElement = document.querySelector('[data-load="cart-drawer"]');
    if (toggleCart) {
      toggleCart.click();
      window.history.replaceState(null, null, window.location.pathname);
    }
  }
};

export default component;
